<template>
	<v-snackbar
		v-model="show"
		:timeout="timeout"
		:color="color"
		auto-height
		top
		right
	>
		{{ notificationText }}
		<v-btn
			v-if="route"
			:to="route"
			flat
		>
			Go
		</v-btn>
		<v-btn
			flat
			@click="show = false"
		>
			Close
		</v-btn>
	</v-snackbar>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			timeout: 6000,
			notificationText: '',
			color: 'primary',
			route: null,
		};
	},
	computed: {
		notification() {
			return this.$store.get('notification');
		},
	},
	watch: {
		notification(notification) {
			if (notification.text === '') {
				return;
			}
			this.setNotificationColor(notification.type);
			this.setNotificationRoute(notification.to);
			this.show = true;
			this.notificationText = notification.text;
			this.$store.set('notification', { type: 'primary', text: '', to: '' });
		},
	},
	methods: {
		setNotificationColor(type) {
			switch (type) {
			case 'error': this.color = 'error';
				break;
			case 'success': this.color = 'success';
				break;
			case 'info': this.color = 'info';
				break;
			default: this.color = 'primary';
			}
		},
		setNotificationRoute(route) {
			if (route !== '') {
				this.route = route;
			}
			else {
				this.route = null;
			}
		},
	},
};
</script>

<style>

</style>
